export default "__VITE_ASSET__9BkjhI9Y__"